import React from "react";
import { Box } from "@mui/material";
import { useMyLeaveBadges } from "my-leave/hooks";
import { OcSidebarBadge } from "oc/components/sidebar-badge";

export const MyLeaveMenuBadges = () => {
  const { data } = useMyLeaveBadges();
  const urgentLeaveRequestsCount = data?.urgentLeaveRequestsCount ?? 0;
  const normalLeaveRequestsCount =
    data?.allLeaveRequestsCount - data?.urgentLeaveRequestsCount;

  if (
    !data ||
    (urgentLeaveRequestsCount === 0 && normalLeaveRequestsCount === 0)
  )
    return null;

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <OcSidebarBadge
        value={urgentLeaveRequestsCount}
        urgent
        id="myLeaveMenuBadge"
      />
      <OcSidebarBadge value={normalLeaveRequestsCount} id="myLeaveMenuBadge" />
    </Box>
  );
};
